import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BackIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="back icon">
      {/* <title>back icon</title> */}
      <path
        d="M22.2903 12.0019C22.2903 17.2917 17.9821 21.5999 12.6923 21.5999C10.5987 21.5999 8.61264 20.932 6.93954 19.6769C6.33425 19.2229 6.21208 18.3626 6.66626 17.756C7.12022 17.1507 7.97885 17.0298 8.58714 17.4827C9.78056 18.3791 11.202 18.8519 12.6972 18.8519C16.4732 18.8521 19.5468 15.7785 19.5468 12.0019C19.5468 8.22534 16.4736 5.15176 12.6966 5.15176C11.0908 5.15176 9.56344 5.73004 8.35416 6.72241L10.2883 8.65744C11.0175 9.38704 10.5007 10.6336 9.46956 10.6336H3.22167C2.7677 10.6345 2.3999 10.2658 2.3999 9.81142L2.3999 3.55882C2.3999 2.52829 3.64605 2.01217 4.37479 2.74134L6.41527 4.7831C8.13982 3.28747 10.3518 2.4044 12.6923 2.4044C17.9821 2.4044 22.2903 6.71213 22.2903 12.0019Z"
        fill={props.fill || "currentColor" || "#F5F5F5"}
      />
    </svg>
  );
};

export default BackIcon;
